import { types, getParent } from 'mobx-state-tree';

const Wager = types.model('Wager', {
    bytes32Id: types.string,
    eventId: types.string,
    maker: types.string,
    value: types.number,
    odds: types.number,
    makerChoice: types.number,
    //takerChoice: types.number,
    //makerWinVote: types.number,
    //takerWinVote: types.number,
    //takerWinVote: types.number,
    //winner: types.string,
    settled: types.boolean,
    cancelled: types.boolean,
    selectedTeam: types.string,
    team_one: types.string,
    team_two: types.string,
    eventStartTime: types.number,
    eventDuration: types.optional(types.number, 100),
    eventBytes32Id: types.string,
    isPropWager: types.optional(types.boolean, false),
    originalEventId: types.optional(types.string, ""),
    isPrivate: types.optional(types.boolean, false)
}).actions(self => ({
    incrementValue() {
        //self.value = self.value + 0.05;
        self.value = self.value + 50000000000000000;
    },
    decrementValue() {
        //if(self.value >= 0.01) {
        // self.value = self.value - 0.05;
        if (self.value >= 100000000000000000) {
            self.value = self.value - 50000000000000000;
        }
    },
    incrementOdds() {
        self.odds = self.odds + 1;
        console.log(self.odds);
    },
    changePrivacy() {
        self.isPrivate = !self.isPrivate;        
    },
    decrementOdds() {
        if (self.odds > 2) {
            self.odds = self.odds - 1;
        } else {
            self.odds = 1;
        }
        console.log(self.odds);
    },
    setValue(value) {
        self.value = value;
    },
    setOdds(odds) {
        // if (odds > 0){
        self.odds = odds;
        // } else {
        //     self.odds = 100;
        // }
        console.log("odds: " + odds);
    },
    remove() {
        getParent(self, 2).remove(self);
    }
}))
    .views(self => ({
        total() {
            return self.value / (self.odds / 100);
        },
        stake() {
            return self.value;
        }
    }));

export default Wager;


// WEBPACK FOOTER //
// ./src/stores/BetSlipStore/Wager.js